export enum ListType {
  INFINITE_SCROLL = 'INFINITE_SCROLL',
  PAGINATION = 'PAGINATION',
}

export enum WorklistTabNames {
  WORKLIST = 'workList',
  STUDY_LIST = 'studyList',
}
